import EditAddressForm from './EditAddressForm';

export default EditAddressForm;


// WEBPACK FOOTER //
// ./src/components/EditAddressForm/index.jsx